import UIComponent from "../../common/UIComponent";
import "./index.css";
import { lockOrientationUniversal } from '../../common/Utils';

/**
 * @description 全屏功能 - UI 控件
 */
export default class H5FullScreenBtn extends UIComponent {

  constructor(elementId, interfaces) {
    super(interfaces)
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.init();
    this.interfaces.on(VhallPlayer.FULLSCREEN_CHANGE, res => {
      if (res === 'fullscreen') {
        // this.h5fullscreenBtn.classList.add("icontuichuquanping_wendangbeifen");
        // this.h5fullscreenBtn.classList.remove("iconyuandaxiao_wendangbeifen");
        this.h5fullscreenBtn.classList.add("full");
      } else {
        // this.h5fullscreenBtn.classList.add("iconyuandaxiao_wendangbeifen");
        // this.h5fullscreenBtn.classList.remove("icontuichuquanping_wendangbeifen");
        this.h5fullscreenBtn.classList.remove("full");
      }
    });
  }

  init() {
    this.h5fullscreenBtn = document.createElement("span");
    this.h5fullscreenBtn.setAttribute("class", "vhallPlayerh5-fullscreenBtn");
    this.h5fullscreenBtn.onclick = this.handlerBtnClick.bind(this);
    this.insertElement(this.elementId, this.h5fullscreenBtn);
  }


  handlerBtnClick() {
    if (this.interfaces.isFullscreen()) {
      this.interfaces.exitFullScreen();
    } else {
      this.interfaces.enterFullScreen();
      if(this.theme){
        lockOrientationUniversal('landscape');
      }
    }
  }

}